import { Loader } from '@googlemaps/js-api-loader'

const BANNER_MAP_SECTION_SELECTOR = '.offset-banner-section--map'
const MAP_SECTION_SELECTOR = '.offset-banner__map-image'
const API_KEY = window.MAPS_KEY.value
let map = undefined

function getMarkerWindow(label) {
    return `
    <div class="marker-info">
        <h6 class="text-grey-900">${label.innerText}</h6>
        <a class="font-size-3 text-blue-400" href="${label.dataset.href}">View listing</a>
    </div>
    `
}

function decorateLabel(label) {

    const split = label.dataset.latlng.split(',')

    const position = {
        lat: parseFloat(split[0]),
        lng: parseFloat(split[1])
    } 

    const marker = new google.maps.Marker({
        position,
        map,
    })

    const content = getMarkerWindow(label)

    const info = new google.maps.InfoWindow({
        content
    })

    const openInfo = () => {
        info.open({
            anchor: marker,
            map
        })
    }

    label.addEventListener('click', openInfo)
    marker.addListener('click', openInfo)

}

function decorateSection(section) {

    const mapContainer = section.querySelector(MAP_SECTION_SELECTOR)
    const labels = Array.from(section.querySelectorAll('[data-latlng]'))

    const center = {
        lat: -36.8472119,
        lng: 174.7669954
    }

    const options = {
        center,
        zoom: 13
    }

    map = new google.maps.Map(mapContainer, options)

    if (labels.length < 1) {
        return
    }

    labels.forEach(decorateLabel)
}

function setup() {

    const sections = Array.from(document.querySelectorAll(BANNER_MAP_SECTION_SELECTOR))

    if (sections.length < 1) {
        return
    }

    sections.forEach(decorateSection)

}

export function init() {

    if (!API_KEY) {
        throw 'Google maps will not work without an API_KEY'
    }

    const loader = new Loader({
        apiKey: API_KEY,
    })

    loader.load().then(setup)

}
